import React, { useCallback, useState } from "react";
import Camera from "../Header/VideoCall/Camera";
import Close from "@/SvgIcons/Close";
import styles from "./header-opt.module.scss";


const VideoCounselling = ({showTooltip = true}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(showTooltip);
  const closeTooltip = useCallback(() => {
    setIsTooltipOpen(false);
  }, []);

  return (
    <div className={styles.videoBtnContainer}>
      <a href="https://widget01.popin.to/share/12338" target="_blank"  className={styles.videoBtnWrapper} aria-label="Start video call">
        <Camera className={styles.videoIcon} />
      </a>
      {isTooltipOpen && (
        <div className={styles.tooltip} role="tooltip">
          <button
            onClick={closeTooltip}
            aria-label="Close tooltip"
            className={styles.tooltipClose}
          >
            <Close className={styles.tooltipCloseIcon} color="#1a325d" />
          </button>
          <span className={styles.tooltipText}>
            Video call our career counsellor now!
          </span>
        </div>
      )}
    </div>
  );
};

export default React.memo(VideoCounselling);
